import {getPrivateAxios} from '../../libs';

export const fetchGuidePdf = async (id: string) => {
  return getPrivateAxios()
    .get(`guides/${id}/print`, {responseType: 'blob'})
    .then((response) => {
      return response.data;
    });
};
